import { CSSProperties } from "react";
import { Button } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

export const DefaultContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 5px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: space-between;
`;

export const NewRegister = styled(Button)`
  height: ${(props) => props.theme["@height-button-lg"]};
  width: 140px;
  margin-left: auto;
`;

export const DocumentIcon: CSSProperties = {
  marginRight: "10px",
  alignItems: "center",
  color: theme["@primary-color-brand"],
};
